<template>
  <div v-show="!loading" class="teastodaycourselist-div">
    <van-empty v-if="list.length == 0" description="暂无数据" />
    <div class="list-content" v-else>
      <div
        class="listitem-content"
        v-for="(item, index) in list"
        :key="'listitem' + index"
      >
        <div class="item-classname-content" :class="item.calssTypeValue == 1 ? 'item-classname-content-out' : 'item-classname-content-main'">
          <div class="item-classname-logo" :class="item.calssTypeValue == 1 ? 'item-classname-logo-out' : 'item-classname-logo-main'">{{ item.calssTypeValue == 1 ? "外" : "主"}}</div>
          <div class="item-classname-text">{{ item.orgName || "" }}</div>
        </div>
        <template v-if="item.orgCourses && item.orgCourses.length > 0">
          <div
            v-for="(tempItem, tempIndex) in item.orgCourses"
            :key="index + 'courseitem' + tempIndex"
          >
            <DsfMobileTeasCell cellShape="none" :border="true" :title="tempItem.courseName || ''">
              <DsfMobileTeasCellItem
                :value=" tempItem.teachingMode || '暂无' "
                icon="icon-icon-kcfl"
              >
              </DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem
                :value=" tempItem.courseTime || '暂无' "
                icon="icon-shijian2"
              >
              </DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem
                :value=" tempItem.teacher || '暂无' "
                icon="icon-icon-teacher"
              >
              </DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem
                :value=" tempItem.classroom || '暂无' "
                icon="icon-location-hollow"
              >
              </DsfMobileTeasCellItem>
            </DsfMobileTeasCell>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasTodayCourseList",
  mixins: [$mixins.control],
  ctrlCaption: "今日课程列表",
  design: {
    isMask: false,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      active: null,
      noticeInfo: "",
      showNoticeDialog: false,
    };
  },
  watch: {
    url() {
      this.postData();
    },
  },
  created() {
    if (this.isDesign) {
      this.list = [];
    } else {
      this.postData();
    }
  },
  methods: {
    itemClick(item) {
      this.$emit("itemClick", item);
    },
    reloadData() {
      this.postData();
    },
    postData() {
      if (this.isDesign) return;
      if (!this.url || this.url == "") {
        this.list = {};
        return;
      }
      this.loading = true;
      const loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .get(this.url)
        .done(({ success, data, message }) => {
          if (success) {
            let tempObject = data || {};
            let keyArray = Object.keys(tempObject);
            if (keyArray.length > 0) {
              let tempArray = [];
              keyArray.forEach((item) => {
                let tempItem = item || "";
                let dayArray = tempObject[tempItem] || [];
                if (dayArray.length > 0) {
                  tempArray.push(...dayArray);
                }
                _this.list = tempArray;
              });
            } else {
              _this.list = [];
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          console.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        })
        .finally(() => {
          this.loading = false;
          dsf.layer.closeLoading(loading);
        });
    },
  },
});
</script>